import { useAssistantState } from '@assistant-ui/react'
import { SearchIcon } from 'lucide-react'
import { extractLastDataPart } from '#app/utils/data-parts.js'

/**
 * Shows a loading indicator while the engine searches, until the first text
 * arrives (the `imLoading` data part in resources+/chat.ts).
 */
export function SearchLoadingIndicator() {
	const loading = useAssistantState(
		({ message }) =>
			extractLastDataPart<boolean>(
				message.metadata as Record<string, unknown> | undefined,
				'imLoading',
			) ?? false,
	)

	if (!loading) return null

	return (
		<div className="mt-4 flex flex-col gap-2">
			<div className="flex items-center gap-2 rounded-md border border-border/60 bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
				<SearchIcon className="size-4 shrink-0 animate-pulse" />
				<span>
					Söker i Internetmedicins behandlingsöversikter
					<span className="inline-flex w-6">
						<span className="animate-dots" />
					</span>
				</span>
			</div>
		</div>
	)
}
